import Vue from "vue";

export const CreditNoteEventBus = new Vue();
